module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('block', {
    attrs: {
      "title": "Centres d'intérêt"
    }
  }, [_c('div', {
    attrs: {
      "id": "hobbies"
    }
  }, [_vm._l((_vm.hobbies), function(hobby) {
    return [_c('list-item', [_c('span', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(hobby.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(hobby.description)
      }
    })])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f35d966"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hobbies.vue
// module id = 298
// module chunks = 1